import React from 'react';
import { BrowserRouter as Link } from 'react-router-dom';
import './App.css';
import logo from './images/logo.png';
import MpegLcevcLogo from './images/mpeg5_lcevc_logo.png';
import Amplify from 'aws-amplify';
import { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
import { Authenticator, SignIn } from 'aws-amplify-react';
import { Analytics, Storage, API, graphqlOperation } from 'aws-amplify';
import * as queries from './graphql/queries';
import * as subscriptions from './graphql/subscriptions';
import * as constant from './Constant';
import * as version from './Version';
import queryString from 'query-string';

Amplify.configure(awsconfig);

class Login extends React.Component {

   constructor(props) {
    super(props);
    var self = this;
    this.state = {
      luser: '',
      lpass: '',
      showLoginBtn: true,
      showPassword: false,
      isStaging: true,
      isDebug: false,
      showLoader:true,
      showWelcomePopup: '0',
 };
    this.onInit();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onInit() {

    var isIOS = (/iPhone/i.test(navigator.userAgent)); 

    if (isIOS) {
      this.isHEVCSupport = "false";
      localStorage.setItem('isHEVCSupport', this.isHEVCSupport);
    } else {
        if (MediaSource.isTypeSupported('video/mp4; codecs=hvc1.2.4.L123.B0')) {
          this.isHEVCSupport = "true";
          localStorage.setItem('isHEVCSupport', this.isHEVCSupport);
        } else {
          this.isHEVCSupport = "false";
          localStorage.setItem('isHEVCSupport', this.isHEVCSupport);
        }
    }

    this.checkAv1Supported();

  }

  // Check if the AV1 codec is supported by the user's browser.
  checkAv1Supported() {
    const browser = navigator.userAgent;

    if (browser.indexOf('Chrome') >= 0 || browser.indexOf('Firefox') >= 0 || browser.indexOf('Edge') >= 0 || browser.indexOf('Opera') >= 0) {
      this.isAV1Support = "true";
      localStorage.setItem('isAV1Support', this.isAV1Support);
    } else {
      this.isAV1Support = "false";
      localStorage.setItem('isAV1Support', this.isAV1Support);
    }
  }

  componentDidMount() {

    var isAuthenticated = localStorage.getItem('isAuthenticated');
    var fromRoute = localStorage.getItem('fromRoute');
    // console.log(isAuthenticated);
    // console.log(fromRoute);

    if(isAuthenticated) {
      this.props.history.push('/'+fromRoute)
    } else {
      const value = queryString.parse(this.props.location.search);
      //console.log(value);

      localStorage.setItem('urltab', '1');

      if ( isNaN(value.tab) ) {
        localStorage.setItem('urlTabName', '1');
      } else {
        localStorage.setItem('urlTabName', value.tab);
      }

      if( (value.user != null && value.user != undefined) && (value.pwd != null && value.pwd != undefined) ) {
          Auth.signIn(value.user, value.pwd)
          .then(user => this.displaydata(user))
          .catch(err => this.displayerror(err,value)); 
      } else {
        this.setState({
            showLoader : false,
          });
      }
    }
    
  }

  handleChange(event) {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const condition = navigator.onLine ? 'online' : 'offline';
    if(condition == 'online') {
      if(this.state.luser.match(/\s/g)) {
        alert('Spaces are not allowed in the username field');
        window.$("#luser").focus();
      } else if(this.state.lpass.match(/\s/g)) {
        alert('Spaces are not allowed in the password field');
        window.$("#lpass").focus();
      } else {
        this.setState({
          showLoginBtn : false,
        });
        Auth.signIn({
          username: this.state.luser,
          password: this.state.lpass
        }).then(user => this.displaydata(user))
        .catch(err => this.displayerror(err)); 
      }
    } else {
      alert('Kindly check your internet Connection');
    }   
    
  }

  displayerror(err,urlval) {
    let cookieValue = document.cookie.split(';').reduce((ac, str) => Object.assign(ac, {[str.split('=')[0].trim()]: str.split('=')[1]}), {});
    //console.log(cookieValue.loginAttempt);
    this.setState({
      showLoginBtn : true,
    });
    //alert(err.message);
    if(cookieValue.loginAttempt == undefined || cookieValue.loginAttempt == 0) {
      document.cookie = "loginAttempt=1";
      if(urlval == undefined) {
        alert(err.message + ' Only 2 attempts left')
      } else {
        alert(err.message + ' Only 2 attempts left')
        this.props.history.push('/');
        window.location.reload();
      }
    } else {
      let cookieValue = document.cookie.split(';').reduce((ac, str) => Object.assign(ac, {[str.split('=')[0].trim()]: str.split('=')[1]}), {});
      console.log(cookieValue.loginAttempt++);
      var newvalue = cookieValue.loginAttempt++;
      document.cookie = "loginAttempt="+newvalue;
      //console.log(newvalue);
      if(newvalue == 2) {
        if(urlval == undefined) {
          alert(err.message + ' Only 1 attempt left')
        } else {
          alert(err.message + ' Only 1 attempt left')
          this.props.history.push('/');
          window.location.reload();
        }
      } else {
        if(urlval == undefined) {
          alert('No attempt left. Please wait for 10 seconds, and try again.');
        } else {
          alert('No attempt left. Please wait for 10 seconds, and try again.');
          this.props.history.push('/');
          window.location.reload();
        }
        document.getElementById("loginbutton").disabled = true;
        CountDown(10);
        function CountDown(duration) {
            if (!isNaN(duration)) {
                var timer = duration, minutes, seconds;
                
                var interVal=  setInterval(function () {
                    minutes = parseInt(timer / 60, 10);
                    seconds = parseInt(timer % 60, 10);
                    minutes = minutes < 10 ? "0" + minutes : minutes;
                    seconds = seconds < 10 ? "0" + seconds : seconds;

                    if (--timer < 0) {
                        timer = duration;
                        clearInterval(interVal)
                        
                        document.getElementById("loginbutton").disabled = false;
                        document.cookie = "loginAttempt=0";
                    }
                    },1000);
                  
            }
        }

      }
    }
    
  }

  displaydata(user) {
    //console.log(user);
    //console.log(user.attributes.profile);
    if (user && user.challengeName && user.challengeName == "NEW_PASSWORD_REQUIRED") {
      this.setState({
          showLoginBtn : true,
        });
      alert('Temporary password cannot be used to login into the App. Kindly reset your password from the platform.');
    } else {

    document.cookie = "loginAttempt=0";

    localStorage.setItem('userFirstName', user.attributes.given_name);
    localStorage.setItem('userLastName', user.attributes.family_name);
    localStorage.setItem('userEmailId', user.attributes.email);
    localStorage.setItem('userSubId', user.attributes.sub);
    localStorage.setItem('userNewMasterId', user.attributes.name);
    localStorage.setItem('imageCacheValue', Math.random())

    localStorage.setItem('userName', user.username);
    localStorage.setItem('isStaging', this.state.isStaging);
    localStorage.setItem('showWelcomePopup', this.state.showWelcomePopup);
    localStorage.setItem('isDebug', this.state.isDebug);

    if(user.username && (user.attributes.name == constant.Master_id)) {
      API.graphql(graphqlOperation(queries.getPlarformSchema, { id: constant.Master_id }))
        .then(data => this.querydata(data,user.username,user.attributes.profile,user.attributes.nickname))
        .catch(err => this.queryerror(err)); 
    } else if (user.username && (user.attributes.name != constant.Master_id)) {
      API.graphql(graphqlOperation(queries.getPlarformSchema, { id: user.attributes.name }))
        .then(data => this.noVnovaUserData(data,user.username,user.attributes.profile,user.attributes.nickname))
        .catch(err => this.queryerror(err));
    } else {
        this.setState({
          showLoginBtn : true,
        });
        alert("ALERT!,An unexpected error occurred,Try again.")
    }

    /*if(user.username && ( (user.attributes.profile == '23') || (user.attributes.profile == '24') ) ) {
      API.graphql(graphqlOperation(queries.getPlarformSchema, { id: user.attributes.name }))
      .then(data => this.querydata(data,user.username,user.attributes.profile,user.attributes.nickname))
        .catch(err => this.queryerror(err));
    } else if(user.username && (user.attributes.name == constant.Master_id) ) {
       API.graphql(graphqlOperation(queries.getPlarformSchema, { id: constant.Master_id }))
      .then(data => this.querydata(data,user.username,user.attributes.profile,user.attributes.nickname))
        .catch(err => this.queryerror(err)); 

    } else {
        this.setState({
          showLoginBtn : true,
        });
        alert("ALERT!,An unexpected error occurred,Try again.")
    }*/ 
    }
  }


  noVnovaUserData(data,username,userProfile,userId) {
    this.listOfAppConfiguration = JSON.parse(data.data.getPlarformSchema.AppConfiguration);
    this.listOfVodAssets = JSON.parse(data.data.getPlarformSchema.VodNew);
    this.listOfLive = JSON.parse(data.data.getPlarformSchema.Live);

    localStorage.setItem('listOfDemoCntLive', JSON.stringify(this.listOfLive));

    localStorage.setItem('changeIdTrigger',data.data.getPlarformSchema.Trigger);
    localStorage.setItem('userProfile',userProfile);
    localStorage.setItem('userProfileName',username);
    localStorage.setItem('userId',userId);

    /*To show the demo for the external users too*/
    if(this.listOfAppConfiguration.ShowDemoContents && this.listOfAppConfiguration.ShowDemoContents == '1') {

      API.graphql(graphqlOperation(queries.getPlarformSchema, { id: constant.Master_id })).then(data => 
        {
          this.listOfDemoVodAssets = JSON.parse(data.data.getPlarformSchema.VodNew);
          this.listOfDemoLive = JSON.parse(data.data.getPlarformSchema.Live);
          this.listOfDemoContentCategoriesProd = JSON.parse(data.data.getPlarformSchema.ContentCategories);
          this.listOfDemoPromotedContent = JSON.parse(data.data.getPlarformSchema.PromotedContentnew);

          localStorage.setItem('listOfLive', JSON.stringify(this.listOfDemoLive));
          localStorage.setItem('listOfPromotedContent', JSON.stringify(this.listOfDemoPromotedContent));
          let promotedContentArray = [];
          if(this.listOfDemoPromotedContent) {
            for( var i=0; i<this.listOfDemoPromotedContent.length; i++) {
              if( (this.listOfDemoPromotedContent[i].Typeid && this.listOfDemoPromotedContent[i].Typeid == '1') || (this.listOfDemoPromotedContent[i].TypeID && this.listOfDemoPromotedContent[i].TypeID == '1') || (this.listOfDemoPromotedContent[i].TypeId && this.listOfDemoPromotedContent[i].TypeId == '1') || (this.listOfDemoPromotedContent[i].TypeiD && this.listOfDemoPromotedContent[i].TypeiD == '1') ) {
                promotedContentArray.push(this.listOfDemoPromotedContent[i]);
              }
              if( ( (this.listOfDemoPromotedContent[i].Typeid && this.listOfDemoPromotedContent[i].Typeid == '0') || (this.listOfDemoPromotedContent[i].TypeID && this.listOfDemoPromotedContent[i].TypeID == '0') || (this.listOfDemoPromotedContent[i].TypeId && this.listOfDemoPromotedContent[i].TypeId == '0') || (this.listOfDemoPromotedContent[i].TypeiD && this.listOfDemoPromotedContent[i].TypeiD == '0') ) 
                  && ( (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID] && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].IsEnabled && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].IsEnabled == '1' && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].IsPrivate != '1' || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].IsPrivate == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].Platform == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].Platform == undefined || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].Platform.includes("Website"))) ) 
                  || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid] && this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].IsEnabled && this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].IsEnabled == '1' && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].IsPrivate != '1' || this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].IsPrivate == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].Platform == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].Platform == undefined || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].Platform.includes("Website"))) ) 
                  || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId] && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].IsEnabled && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].IsEnabled == '1' && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].IsPrivate != '1' || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].IsPrivate == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].Platform == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].Platform == undefined || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].Platform.includes("Website"))) ) 
                  || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD] && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].IsEnabled && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].IsEnabled == '1' && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].IsPrivate != '1' || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].IsPrivate == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].Platform == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].Platform == undefined || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].Platform.includes("Website"))) ) ) ) {
                
                    promotedContentArray.push(this.listOfDemoVodAssets[this.listOfDemoPromotedContent[i].Contentid] || this.listOfDemoVodAssets[this.listOfDemoPromotedContent[i].ContentID] || this.listOfDemoVodAssets[this.listOfDemoPromotedContent[i].ContentId] || this.listOfDemoVodAssets[this.listOfDemoPromotedContent[i].ContentiD]);
              }
              localStorage.setItem('promotedContentArray', JSON.stringify(promotedContentArray));
            }
          }// end of promoted contents

          let newContentCategory = [];
    
          for(var i=0; i<Object.keys(this.listOfDemoContentCategoriesProd).length; i++) {
            /*For Content Category Names*/
            if(this.listOfDemoContentCategoriesProd[Object.keys(this.listOfDemoContentCategoriesProd)[i]].Status == '1') {
              newContentCategory.push( {
                title: this.listOfDemoContentCategoriesProd[Object.keys(this.listOfDemoContentCategoriesProd)[i]].Title[0] + ' Demo',
                serial: this.listOfDemoContentCategoriesProd[Object.keys(this.listOfDemoContentCategoriesProd)[i]].Serial,
                Bouquet: this.listOfDemoContentCategoriesProd[Object.keys(this.listOfDemoContentCategoriesProd)[i]].Bouquet,
                Status: this.listOfDemoContentCategoriesProd[Object.keys(this.listOfDemoContentCategoriesProd)[i]].Status,
                vertical: '1'
              })
              // sort by serial
              newContentCategory.sort(function (a, b) {
                return a.serial - b.serial;
              });
            }
          }//end of Content Category Names


          let finalLists = [];
          for(var i=0; i<newContentCategory.length; i++) {
            /*For Content Category Bouquet*/
            if(newContentCategory[i].Status == '1') {
              let listBouquets = newContentCategory[i].Bouquet
              let perfinalList = [];
              if(listBouquets) {
                listBouquets.forEach((listBouquet)=>{
                  if(listBouquet.Name != null && listBouquet.ContentIdwithType !== null) {
                  let list = {Name :listBouquet.Name[0], Contents : [], contentType : []};
                  listBouquet.ContentIdwithType.forEach((Contents)=> {
                    if(Contents.Type == 'VOD') {

                      if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {

                        if( (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfDemoVodAssets[Contents.ContentId].Codec && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '4') && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentId].Platform == null || this.listOfDemoVodAssets[Contents.ContentId].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentId].Platform.includes("Website")))) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfDemoVodAssets[Contents.ContentID].Codec && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '4') && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentID].Platform == null || this.listOfDemoVodAssets[Contents.ContentID].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentID].Platform.includes("Website"))) ) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfDemoVodAssets[Contents.Contentid].Codec && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '3') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '4') && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == null || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfDemoVodAssets[Contents.Contentid].Platform == null || this.listOfDemoVodAssets[Contents.Contentid].Platform == undefined || (this.listOfDemoVodAssets[Contents.Contentid].Platform.includes("Website")))) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfDemoVodAssets[Contents.ContentiD].Codec && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '4') && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentiD].Platform == null || this.listOfDemoVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
                          
                          list.Contents.push(this.listOfDemoVodAssets[Contents.ContentId] || this.listOfDemoVodAssets[Contents.ContentID] || this.listOfDemoVodAssets[Contents.Contentid] || this.listOfDemoVodAssets[Contents.ContentiD])
                          list.contentType.push({
                            type: 'VOD',
                            contentId: Contents.ContentID
                          })
          
                          if(this.listOfAppConfiguration.Contentorder == '1') {
                            list.Contents.sort(function(a, b) {
                              return a.Title.localeCompare(b.Title);
                            });
                          }
                        }

                      } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {

                        if( (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfDemoVodAssets[Contents.ContentId].Codec && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '4') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentId].Platform == null || this.listOfDemoVodAssets[Contents.ContentId].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentId].Platform.includes("Website")))) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfDemoVodAssets[Contents.ContentID].Codec && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '4') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentID].Platform == null || this.listOfDemoVodAssets[Contents.ContentID].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentID].Platform.includes("Website"))) ) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfDemoVodAssets[Contents.Contentid].Codec && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '3') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '4') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '5') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '9') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '6') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '10') && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == null || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfDemoVodAssets[Contents.Contentid].Platform == null || this.listOfDemoVodAssets[Contents.Contentid].Platform == undefined || (this.listOfDemoVodAssets[Contents.Contentid].Platform.includes("Website")))) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfDemoVodAssets[Contents.ContentiD].Codec && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '4') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentiD].Platform == null || this.listOfDemoVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
                          
                          list.Contents.push(this.listOfDemoVodAssets[Contents.ContentId] || this.listOfDemoVodAssets[Contents.ContentID] || this.listOfDemoVodAssets[Contents.Contentid] || this.listOfDemoVodAssets[Contents.ContentiD])
                          list.contentType.push({
                            type: 'VOD',
                            contentId: Contents.ContentID
                          })
          
                          if(this.listOfAppConfiguration.Contentorder == '1') {
                            list.Contents.sort(function(a, b) {
                              return a.Title.localeCompare(b.Title);
                            });
                          }
                        }

                      } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {

                        if( (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfDemoVodAssets[Contents.ContentId].Codec && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentId].Platform == null || this.listOfDemoVodAssets[Contents.ContentId].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentId].Platform.includes("Website")))) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfDemoVodAssets[Contents.ContentID].Codec && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentID].Platform == null || this.listOfDemoVodAssets[Contents.ContentID].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentID].Platform.includes("Website"))) ) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfDemoVodAssets[Contents.Contentid].Codec && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '5') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '9') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '6') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '10') && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == null || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfDemoVodAssets[Contents.Contentid].Platform == null || this.listOfDemoVodAssets[Contents.Contentid].Platform == undefined || (this.listOfDemoVodAssets[Contents.Contentid].Platform.includes("Website")))) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfDemoVodAssets[Contents.ContentiD].Codec && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentiD].Platform == null || this.listOfDemoVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
                          
                          list.Contents.push(this.listOfDemoVodAssets[Contents.ContentId] || this.listOfDemoVodAssets[Contents.ContentID] || this.listOfDemoVodAssets[Contents.Contentid] || this.listOfDemoVodAssets[Contents.ContentiD])
                          list.contentType.push({
                            type: 'VOD',
                            contentId: Contents.ContentID
                          })
          
                          if(this.listOfAppConfiguration.Contentorder == '1') {
                            list.Contents.sort(function(a, b) {
                              return a.Title.localeCompare(b.Title);
                            });
                          }
                        }

                      } else {

                        if( (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentId].Platform == null || this.listOfDemoVodAssets[Contents.ContentId].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentId].Platform.includes("Website")))) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentID].Platform == null || this.listOfDemoVodAssets[Contents.ContentID].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentID].Platform.includes("Website"))) ) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == null || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfDemoVodAssets[Contents.Contentid].Platform == null || this.listOfDemoVodAssets[Contents.Contentid].Platform == undefined || (this.listOfDemoVodAssets[Contents.Contentid].Platform.includes("Website")))) 
                        || (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentiD].Platform == null || this.listOfDemoVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
                          
                          list.Contents.push(this.listOfDemoVodAssets[Contents.ContentId] || this.listOfDemoVodAssets[Contents.ContentID] || this.listOfDemoVodAssets[Contents.Contentid] || this.listOfDemoVodAssets[Contents.ContentiD])
                          list.contentType.push({
                            type: 'VOD',
                            contentId: Contents.ContentID
                          })
          
                          if(this.listOfAppConfiguration.Contentorder == '1') {
                            list.Contents.sort(function(a, b) {
                              return a.Title.localeCompare(b.Title);
                            });
                          }
                        }

                      }

                      } else {
                          if( (this.listOfDemoLive.hasOwnProperty(Contents.ContentId) && this.listOfDemoLive[Contents.ContentId].IsEnabled && this.listOfDemoLive[Contents.ContentId].IsEnabled == '1' && (this.listOfDemoLive[Contents.ContentId].IsPrivate != '1' || this.listOfDemoLive[Contents.ContentId].IsPrivate == null || this.listOfDemoLive[Contents.ContentId].IsPrivate == undefined) && (this.listOfDemoLive[Contents.ContentId].AppPlatforms == null || this.listOfDemoLive[Contents.ContentId].AppPlatforms == undefined || (this.listOfDemoLive[Contents.ContentId].AppPlatforms.includes("Website")))) || (this.listOfDemoLive.hasOwnProperty(Contents.ContentID) && this.listOfDemoLive[Contents.ContentID].IsEnabled && this.listOfDemoLive[Contents.ContentID].IsEnabled == '1' && (this.listOfDemoLive[Contents.ContentID].IsPrivate != '1' || this.listOfDemoLive[Contents.ContentID].IsPrivate == null || this.listOfDemoLive[Contents.ContentID].IsPrivate == undefined) && (this.listOfDemoLive[Contents.ContentID].AppPlatforms == null || this.listOfDemoLive[Contents.ContentID].AppPlatforms == undefined || (this.listOfDemoLive[Contents.ContentID].AppPlatforms.includes("Website"))) ) || (this.listOfDemoLive.hasOwnProperty(Contents.Contentid) && this.listOfDemoLive[Contents.Contentid].IsEnabled && this.listOfDemoLive[Contents.Contentid].IsEnabled == '1' && (this.listOfDemoLive[Contents.Contentid].IsPrivate != '1' || this.listOfDemoLive[Contents.Contentid].IsPrivate == null || this.listOfDemoLive[Contents.Contentid].IsPrivate == undefined) &&(this.listOfDemoLive[Contents.Contentid].AppPlatforms == null || this.listOfDemoLive[Contents.Contentid].AppPlatforms == undefined || (this.listOfDemoLive[Contents.Contentid].AppPlatforms.includes("Website")))) || (this.listOfDemoLive.hasOwnProperty(Contents.ContentiD) && this.listOfDemoLive[Contents.ContentiD].IsEnabled && this.listOfDemoLive[Contents.ContentiD].IsEnabled == '1' && (this.listOfDemoLive[Contents.ContentiD].IsPrivate != '1' || this.listOfDemoLive[Contents.ContentiD].IsPrivate == null || this.listOfDemoLive[Contents.ContentiD].IsPrivate == undefined) && (this.listOfDemoLive[Contents.ContentiD].AppPlatforms == null || this.listOfDemoLive[Contents.ContentiD].AppPlatforms == undefined || (this.listOfDemoLive[Contents.ContentiD].AppPlatforms.includes("Website")))) ){
                            list.Contents.push(this.listOfDemoLive[Contents.ContentId] || this.listOfDemoLive[Contents.ContentID] || this.listOfDemoLive[Contents.Contentid] || this.listOfDemoLive[Contents.ContentiD] )
                            list.contentType.push({
                              type: Contents.Type,
                              contentId: Contents.ContentID
                            })
          
                            if(this.listOfAppConfiguration.Contentorder == '1') {
                              list.Contents.sort(function(a, b) {
                                return a.Title[0].localeCompare(b.Title[0]);
                              });
                            }
                          }
                      }
                  });

                  if(list.Contents.length > '0') {
                    perfinalList.push(list)
                  }
                        
                  } 
                });
              }
              finalLists.push(perfinalList);
            }
          }// end of the finalLists for loop

          if(this.listOfVodAssets) {
            let perfinalList = [];
            let list = {Name :'', Contents : []};

            for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
              if(this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate != '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == '1' ) {
                list.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
                  //sort by alphabet
                  if(this.listOfAppConfiguration.Contentorder == '1') {
                    list.Contents.sort(function(a, b) {
                      return a.Title[0].localeCompare(b.Title[0]);
                    });
                  } else {
                    // sort by JobID
                    list.Contents.sort(function (a, b) {
                      return b.JobID - a.JobID;
                    });
                  }
              }
            }

            for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
              
              if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {

                if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
                  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
                  //sort by alphabet
                  if(this.listOfAppConfiguration.Contentorder == '1') {
                    list.Contents.sort(function(a, b) {
                      return a.Title.localeCompare(b.Title);
                    });
                  } else {
                    // sort by JobID
                    list.Contents.sort(function (a, b) {
                      return b.JobID - a.JobID;
                    });
                  }
                }

              } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {

                if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
                  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
                  //sort by alphabet
                  if(this.listOfAppConfiguration.Contentorder == '1') {
                    list.Contents.sort(function(a, b) {
                      return a.Title.localeCompare(b.Title);
                    });
                  } else {
                    // sort by JobID
                    list.Contents.sort(function (a, b) {
                      return b.JobID - a.JobID;
                    });
                  }
                }

              } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {

                if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
                  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
                  //sort by alphabet
                  if(this.listOfAppConfiguration.Contentorder == '1') {
                    list.Contents.sort(function(a, b) {
                      return a.Title.localeCompare(b.Title);
                    });
                  } else {
                    // sort by JobID
                    list.Contents.sort(function (a, b) {
                      return b.JobID - a.JobID;
                    });
                  }
                }

              } else {
                if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
                  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
                  //sort by alphabet
                  if(this.listOfAppConfiguration.Contentorder == '1') {
                    list.Contents.sort(function(a, b) {
                      return a.Title.localeCompare(b.Title);
                    });
                  } else {
                    // sort by JobID
                    list.Contents.sort(function (a, b) {
                      return b.JobID - a.JobID;
                    });
                  }
                }
              }
       
            }

            newContentCategory.push( {
              title: 'My VOD',
              vertical: '0'
            })

            if(list.Contents.length > '0') {
              perfinalList.push(list)
            }

            finalLists.push(perfinalList);
          }//end of external user vod asset parsing

        if(this.listOfLive) {
          let perfinalList = [];
          let list = {Name :'', Contents : []};
          for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
            if(this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate != '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == '0' || this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == null) ) {
              list.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
                //sort by alphabet
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  list.Contents.sort(function(a, b) {
                    return a.Title[0].localeCompare(b.Title[0]);
                  });
                } else {
                  // sort by JobID
                  list.Contents.sort(function (a, b) {
                    return b.JobID - a.JobID;
                  });
                }
            }
          }
          newContentCategory.push( {
            title: 'My LIVE',
            vertical: '0'
          })

          if(list.Contents.length > '0') {
            perfinalList.push(list)
          }

          finalLists.push(perfinalList);
        }//end of external user live parsing

        /*Mycontent parsing*/
        if(userProfile == '21') {
          let perfinalprivateUserContent = [];
          let privateUserContent = {Name :'', Contents : []};
          for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              //sort by alphabet
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  privateUserContent.Contents.sort(function(a, b) {
                    return a.Title.localeCompare(b.Title);
                  });
                } else {
                  // sort by JobID
                  privateUserContent.Contents.sort(function (a, b) {
                    return b.JobID - a.JobID;
                  });
                }
            }
          }
          for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
            if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == username && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
              //sort by alphabet
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  privateUserContent.Contents.sort(function(a, b) {
                    return a.Title[0].localeCompare(b.Title[0]);
                  });
                } else {
                  // sort by JobID
                  privateUserContent.Contents.sort(function (a, b) {
                    return b.JobID - a.JobID;
                  });
                }
            }
          }
          newContentCategory.push( {
            title: 'My Content',
            vertical: '0'
          })
          
          perfinalprivateUserContent.push(privateUserContent);
          finalLists.push(perfinalprivateUserContent);
        } else {
          let perfinalprivateUserContent = [];
            let privateUserContent = {Name :'', Contents : []};
            for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
              if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
                privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
                //sort by alphabet
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  privateUserContent.Contents.sort(function(a, b) {
                    return a.Title.localeCompare(b.Title);
                  });
                } else {
                  // sort by JobID
                  privateUserContent.Contents.sort(function (a, b) {
                    return b.JobID - a.JobID;
                  });
                }
              }
            }
            for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
              if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == username && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
                privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
                //sort by alphabet
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  privateUserContent.Contents.sort(function(a, b) {
                    return a.Title[0].localeCompare(b.Title[0]);
                  });
                } else {
                  // sort by JobID
                  privateUserContent.Contents.sort(function (a, b) {
                    return b.JobID - a.JobID;
                  });
                }
              }
            }
            if(privateUserContent.Contents.length != '0') {
              newContentCategory.push( {
                title: 'My Content',
                vertical: '0'
              })
            }

            perfinalprivateUserContent.push(privateUserContent);
            finalLists.push(perfinalprivateUserContent);
        }//end of Mycontent parsing

        //localStorage.setItem('promotedContentArray', JSON.stringify(promotedContentArray));

        localStorage.setItem('newContentCategory', JSON.stringify(newContentCategory));

        localStorage.setItem('jfinalLists', JSON.stringify(finalLists));

        localStorage.setItem('bgColor',this.listOfAppConfiguration.Color);
        localStorage.setItem('contentStatsText',this.listOfAppConfiguration.Contentstats[0]);
        localStorage.setItem('textColor',this.listOfAppConfiguration.TextColor);
        localStorage.setItem('welcomeMsg',this.listOfAppConfiguration.WelcomeMessage[0]);
        localStorage.setItem('contentCategories',this.listOfAppConfiguration.ContentCategories);
        localStorage.setItem('imageBaseURI',this.listOfAppConfiguration.ImageBaseURI);
        localStorage.setItem('videoBaseURI',this.listOfAppConfiguration.VideoBaseURI);
        localStorage.setItem('liveVideoBaseURI',this.listOfAppConfiguration.LiveVideoBaseURI);
        localStorage.setItem('ratingEnable',this.listOfAppConfiguration.Rating);
        localStorage.setItem('contentStats',this.listOfAppConfiguration.Stats);
        localStorage.setItem('durationEnable',this.listOfAppConfiguration.ContentDuration);
        localStorage.setItem('overlayBackground',this.listOfAppConfiguration.OverlayBackground);
        localStorage.setItem('overlayText',this.listOfAppConfiguration.OverlayText);
        localStorage.setItem('overlayTextEnabled',this.listOfAppConfiguration.TextEnabled);
        localStorage.setItem('imagetypeforslider',this.listOfAppConfiguration.Imagetypeforslider);
        localStorage.setItem('imagetypeforlist',this.listOfAppConfiguration.Imagetypeforlist);
        localStorage.setItem('imagetypeforposter',this.listOfAppConfiguration.Imagetypeforposter);
        localStorage.setItem('bypassdetails',this.listOfAppConfiguration.Bypassdetails);
        localStorage.setItem('myaccountemail',this.listOfAppConfiguration.Myaccountemail[0]);
        localStorage.setItem('myaccountfirstname',this.listOfAppConfiguration.Myaccountfirstname[0]);
        localStorage.setItem('myaccountlastname',this.listOfAppConfiguration.Myaccountlastname[0]);
        localStorage.setItem('myaccountsubscriberid',this.listOfAppConfiguration.Myaccountsubscriberid[0]);
        localStorage.setItem('showPromoContent', '1');

        this.props.history.push('/mtab')
        
      })//End of new API call

    } else {
      localStorage.setItem('isVNovaUser','0');

      this.listOfVodAssets = JSON.parse(data.data.getPlarformSchema.VodNew);
      this.listOfLive = JSON.parse(data.data.getPlarformSchema.Live);
      this.listOfContentCategoriesProd = JSON.parse(data.data.getPlarformSchema.ContentCategories);
      this.listOfPromotedContent = [];

      localStorage.setItem('listOfLive', JSON.stringify(this.listOfLive));
      localStorage.setItem('listOfPromotedContent', JSON.stringify(this.listOfPromotedContent));

      let finalLists = [];
      let newContentCategory = [];
      let promotedContentArray = [];

      if(this.listOfVodAssets) {
        let perfinalList = [];
        let list = {Name :'', Contents : []};

        for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
          if(this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate != '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == '1' ) {
            list.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
              //sort by alphabet
              if(this.listOfAppConfiguration.Contentorder == '1') {
                list.Contents.sort(function(a, b) {
                  return a.Title[0].localeCompare(b.Title[0]);
                });
              } else {
                // sort by JobID
                list.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
          }
        }

        for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
          if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {

            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
              list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              //sort by alphabet
              if(this.listOfAppConfiguration.Contentorder == '1') {
                list.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                // sort by JobID
                list.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }

          } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {

            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
              list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              //sort by alphabet
              if(this.listOfAppConfiguration.Contentorder == '1') {
                list.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                // sort by JobID
                list.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }

          } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {

            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
              list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              //sort by alphabet
              if(this.listOfAppConfiguration.Contentorder == '1') {
                list.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                // sort by JobID
                list.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }

          } else {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
              list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              //sort by alphabet
              if(this.listOfAppConfiguration.Contentorder == '1') {
                list.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                // sort by JobID
                list.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }
          }
        }

        newContentCategory.push( {
          title: 'My VOD',
          vertical: '0'
        })

        if(list.Contents.length > '0') {
          perfinalList.push(list)
        }

        finalLists.push(perfinalList);
      }

      if(this.listOfLive) {
        let perfinalList = [];
        let list = {Name :'', Contents : []};
        for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
          if(this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate != '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == '0' || this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == null)) {
            list.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
            //sort by alphabet
            if(this.listOfAppConfiguration.Contentorder == '1') {
              list.Contents.sort(function(a, b) {
                return a.Title[0].localeCompare(b.Title[0]);
              });
            } else {
              // sort by JobID
              list.Contents.sort(function (a, b) {
                return b.JobID - a.JobID;
              });
            }
          }
        }
        newContentCategory.push( {
          title: 'My LIVE',
          vertical: '0'
        })

        if(list.Contents.length > '0') {
          perfinalList.push(list)
        }

        finalLists.push(perfinalList);
      }

      if(userProfile == '21') {
          let perfinalprivateUserContent = [];
          let privateUserContent = {Name :'', Contents : []};
          for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              //sort by alphabet
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  privateUserContent.Contents.sort(function(a, b) {
                    return a.Title.localeCompare(b.Title);
                  });
                } else {
                  // sort by JobID
                  privateUserContent.Contents.sort(function (a, b) {
                    return b.JobID - a.JobID;
                  });
                }
            }
          }
          for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
            if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == username && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
              //sort by alphabet
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  privateUserContent.Contents.sort(function(a, b) {
                    return a.Title[0].localeCompare(b.Title[0]);
                  });
                } else {
                  // sort by JobID
                  privateUserContent.Contents.sort(function (a, b) {
                    return b.JobID - a.JobID;
                  });
                }
            }
          }
          newContentCategory.push( {
            title: 'My Content',
            vertical: '0'
          })
          
          perfinalprivateUserContent.push(privateUserContent);
          finalLists.push(perfinalprivateUserContent);
      } else {
        let perfinalprivateUserContent = [];
          let privateUserContent = {Name :'', Contents : []};
          for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              //sort by alphabet
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  privateUserContent.Contents.sort(function(a, b) {
                    return a.Title.localeCompare(b.Title);
                  });
                } else {
                  // sort by JobID
                  privateUserContent.Contents.sort(function (a, b) {
                    return b.JobID - a.JobID;
                  });
                }
            }
          }
          for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
            if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == username && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
              //sort by alphabet
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  privateUserContent.Contents.sort(function(a, b) {
                    return a.Title[0].localeCompare(b.Title[0]);
                  });
                } else {
                  // sort by JobID
                  privateUserContent.Contents.sort(function (a, b) {
                    return b.JobID - a.JobID;
                  });
                }
            }
          }
          if(privateUserContent.Contents.length != '0') {
            newContentCategory.push( {
              title: 'My Content',
              vertical: '0'
            })
          }

          perfinalprivateUserContent.push(privateUserContent);
          finalLists.push(perfinalprivateUserContent);
      }

      localStorage.setItem('promotedContentArray', JSON.stringify(promotedContentArray));

      localStorage.setItem('newContentCategory', JSON.stringify(newContentCategory));

      localStorage.setItem('jfinalLists', JSON.stringify(finalLists));

      localStorage.setItem('bgColor',this.listOfAppConfiguration.Color);
      localStorage.setItem('contentStatsText',this.listOfAppConfiguration.Contentstats[0]);
      localStorage.setItem('textColor',this.listOfAppConfiguration.TextColor);
      localStorage.setItem('welcomeMsg',this.listOfAppConfiguration.WelcomeMessage[0]);
      localStorage.setItem('contentCategories',this.listOfAppConfiguration.ContentCategories);
      localStorage.setItem('imageBaseURI',this.listOfAppConfiguration.ImageBaseURI);
      localStorage.setItem('videoBaseURI',this.listOfAppConfiguration.VideoBaseURI);
      localStorage.setItem('liveVideoBaseURI',this.listOfAppConfiguration.LiveVideoBaseURI);
      localStorage.setItem('ratingEnable',this.listOfAppConfiguration.Rating);
      localStorage.setItem('contentStats',this.listOfAppConfiguration.Stats);
      localStorage.setItem('durationEnable',this.listOfAppConfiguration.ContentDuration);
      localStorage.setItem('overlayBackground',this.listOfAppConfiguration.OverlayBackground);
      localStorage.setItem('overlayText',this.listOfAppConfiguration.OverlayText);
      localStorage.setItem('overlayTextEnabled',this.listOfAppConfiguration.TextEnabled);
      localStorage.setItem('imagetypeforslider',this.listOfAppConfiguration.Imagetypeforslider);
      localStorage.setItem('imagetypeforlist',this.listOfAppConfiguration.Imagetypeforlist);
      localStorage.setItem('imagetypeforposter',this.listOfAppConfiguration.Imagetypeforposter);
      localStorage.setItem('bypassdetails',this.listOfAppConfiguration.Bypassdetails);
      localStorage.setItem('myaccountemail',this.listOfAppConfiguration.Myaccountemail[0]);
      localStorage.setItem('myaccountfirstname',this.listOfAppConfiguration.Myaccountfirstname[0]);
      localStorage.setItem('myaccountlastname',this.listOfAppConfiguration.Myaccountlastname[0]);
      localStorage.setItem('myaccountsubscriberid',this.listOfAppConfiguration.Myaccountsubscriberid[0]);

      this.props.history.push('/mtab')
    }

    
  }//end of noVnovaUserData

  

  queryerror(err) {
    console.log(err);
  }

  querydata(data,username,userProfile,userId) {
    localStorage.setItem('isVNovaUser','1');
    localStorage.setItem('changeIdTrigger',data.data.getPlarformSchema.Trigger);
    //'userProfile' is a hardcoded value
    localStorage.setItem('userProfile',userProfile);
    localStorage.setItem('userProfileName',username);
    localStorage.setItem('userId',userId);

    this.listOfAppConfiguration = JSON.parse(data.data.getPlarformSchema.AppConfiguration);
    this.listOfPromotedContent = JSON.parse(data.data.getPlarformSchema.PromotedContentnew);
    this.listOfVodAssets = JSON.parse(data.data.getPlarformSchema.VodNew);
    this.listOfLive = JSON.parse(data.data.getPlarformSchema.Live);
    this.listOfContentCategoriesProd = JSON.parse(data.data.getPlarformSchema.ContentCategories);

    //console.log(this.listOfPromotedContent);
    // console.log(this.listOfVodAssets);
    //console.log(this.listOfContentCategoriesProd);
    localStorage.setItem('listOfDemoCntLive', JSON.stringify(this.listOfLive));

    localStorage.setItem('listOfLive', JSON.stringify(this.listOfLive));
    localStorage.setItem('listOfPromotedContent', JSON.stringify(this.listOfPromotedContent));
    let promotedContentArray = [];
    if(this.listOfPromotedContent) {
      for( var i=0; i<this.listOfPromotedContent.length; i++) {
        if( (this.listOfPromotedContent[i].Typeid && this.listOfPromotedContent[i].Typeid == '1') || (this.listOfPromotedContent[i].TypeID && this.listOfPromotedContent[i].TypeID == '1') || (this.listOfPromotedContent[i].TypeId && this.listOfPromotedContent[i].TypeId == '1') || (this.listOfPromotedContent[i].TypeiD && this.listOfPromotedContent[i].TypeiD == '1') ) {
          promotedContentArray.push(this.listOfPromotedContent[i]);
        }
        if( ( (this.listOfPromotedContent[i].Typeid && this.listOfPromotedContent[i].Typeid == '0') || (this.listOfPromotedContent[i].TypeID && this.listOfPromotedContent[i].TypeID == '0') || (this.listOfPromotedContent[i].TypeId && this.listOfPromotedContent[i].TypeId == '0') || (this.listOfPromotedContent[i].TypeiD && this.listOfPromotedContent[i].TypeiD == '0') ) 
            && ( (this.listOfVodAssets[this.listOfPromotedContent[i].ContentID] && this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].IsEnabled && this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].IsEnabled == '1' && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].IsPrivate != '1' || this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].IsPrivate == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].Platform == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].Platform == undefined || (this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].Platform.includes("Website"))) ) 
            || (this.listOfVodAssets[this.listOfPromotedContent[i].Contentid] && this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].IsEnabled && this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].IsEnabled == '1' && (this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].IsPrivate != '1' || this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].IsPrivate == null || this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].Platform == null || this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].Platform == undefined || (this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].Platform.includes("Website"))) ) 
            || (this.listOfVodAssets[this.listOfPromotedContent[i].ContentId] && this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].IsEnabled && this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].IsEnabled == '1' && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].IsPrivate != '1' || this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].IsPrivate == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].Platform == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].Platform == undefined || (this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].Platform.includes("Website"))) ) 
            || (this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD] && this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].IsEnabled && this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].IsEnabled == '1' && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].IsPrivate != '1' || this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].IsPrivate == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].Platform == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].Platform == undefined || (this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].Platform.includes("Website"))) ) ) ) {
          
              promotedContentArray.push(this.listOfVodAssets[this.listOfPromotedContent[i].Contentid] || this.listOfVodAssets[this.listOfPromotedContent[i].ContentID] || this.listOfVodAssets[this.listOfPromotedContent[i].ContentId] || this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD]);
        }
        //console.log(promotedContentArray);
        localStorage.setItem('promotedContentArray', JSON.stringify(promotedContentArray));
      }
    }
     

    let finalLists = [];
    let newContentCategory = [];
    
    for(var i=0; i<Object.keys(this.listOfContentCategoriesProd).length; i++) {
      /*For Content Category Names*/
      //console.log(this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]]);
      if(this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]].Status == '1') {
        newContentCategory.push( {
          title: this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]].Title[0],
          serial: this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]].Serial,
          Bouquet: this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]].Bouquet,
          Status: this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]].Status,
          vertical: '1'
        })
        // sort by serial
        newContentCategory.sort(function (a, b) {
          return a.serial - b.serial;
        });
      }
      
    }

    for(var i=0; i<newContentCategory.length; i++) {
      /*For Content Category Bouquet*/
      if(newContentCategory[i].Status == '1') {
        let listBouquets = newContentCategory[i].Bouquet
      let perfinalList = [];
      if(listBouquets) {
      listBouquets.forEach((listBouquet)=>{
        if(listBouquet.Name != null && listBouquet.ContentIdwithType !== null) {
        let list = {Name :listBouquet.Name[0], Contents : [], contentType : []};
        listBouquet.ContentIdwithType.forEach((Contents)=> {
          if(Contents.Type == 'VOD') {
           //console.log(Contents);
           //console.log(this.listOfVodAssets);

            if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {

              if( (this.listOfVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfVodAssets[Contents.ContentId].Codec && (this.listOfVodAssets[Contents.ContentId].Codec != '3') && (this.listOfVodAssets[Contents.ContentId].Codec != '4') && this.listOfVodAssets[Contents.ContentId].IsEnabled && this.listOfVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentId].IsPrivate == null || this.listOfVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentId].Platform == null || this.listOfVodAssets[Contents.ContentId].Platform == undefined || (this.listOfVodAssets[Contents.ContentId].Platform.includes("Website")))) 
              || (this.listOfVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfVodAssets[Contents.ContentID].Codec && (this.listOfVodAssets[Contents.ContentID].Codec != '3') && (this.listOfVodAssets[Contents.ContentID].Codec != '4') && this.listOfVodAssets[Contents.ContentID].IsEnabled && this.listOfVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentID].IsPrivate == null || this.listOfVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentID].Platform == null || this.listOfVodAssets[Contents.ContentID].Platform == undefined || (this.listOfVodAssets[Contents.ContentID].Platform.includes("Website"))) )
              || (this.listOfVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfVodAssets[Contents.Contentid].Codec && (this.listOfVodAssets[Contents.Contentid].Codec != '3') && (this.listOfVodAssets[Contents.Contentid].Codec != '4') && this.listOfVodAssets[Contents.Contentid].IsEnabled && this.listOfVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfVodAssets[Contents.Contentid].IsPrivate == null || this.listOfVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfVodAssets[Contents.Contentid].Platform == null || this.listOfVodAssets[Contents.Contentid].Platform == undefined || (this.listOfVodAssets[Contents.Contentid].Platform.includes("Website")))) 
              || (this.listOfVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfVodAssets[Contents.ContentiD].Codec && (this.listOfVodAssets[Contents.ContentiD].Codec != '3') && (this.listOfVodAssets[Contents.ContentiD].Codec != '4') && this.listOfVodAssets[Contents.ContentiD].IsEnabled && this.listOfVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentiD].Platform == null || this.listOfVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
                
                list.Contents.push(this.listOfVodAssets[Contents.ContentId] || this.listOfVodAssets[Contents.ContentID] || this.listOfVodAssets[Contents.Contentid] || this.listOfVodAssets[Contents.ContentiD])
                
                list.contentType.push( {
                  type: 'VOD',
                  contentId: Contents.ContentID
                })
                
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  list.Contents.sort(function(a, b) {
                    return a.Title.localeCompare(b.Title);
                  });
                }
              }

            } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {

              if( (this.listOfVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfVodAssets[Contents.ContentId].Codec && (this.listOfVodAssets[Contents.ContentId].Codec != '3') && (this.listOfVodAssets[Contents.ContentId].Codec != '4') && (this.listOfVodAssets[Contents.ContentId].Codec != '5') && (this.listOfVodAssets[Contents.ContentId].Codec != '9') && (this.listOfVodAssets[Contents.ContentId].Codec != '6') && (this.listOfVodAssets[Contents.ContentId].Codec != '10') && this.listOfVodAssets[Contents.ContentId].IsEnabled && this.listOfVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentId].IsPrivate == null || this.listOfVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentId].Platform == null || this.listOfVodAssets[Contents.ContentId].Platform == undefined || (this.listOfVodAssets[Contents.ContentId].Platform.includes("Website")))) 
              || (this.listOfVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfVodAssets[Contents.ContentID].Codec && (this.listOfVodAssets[Contents.ContentID].Codec != '3') && (this.listOfVodAssets[Contents.ContentID].Codec != '4') && (this.listOfVodAssets[Contents.ContentID].Codec != '5') && (this.listOfVodAssets[Contents.ContentID].Codec != '9') && (this.listOfVodAssets[Contents.ContentID].Codec != '6') && (this.listOfVodAssets[Contents.ContentID].Codec != '10') && this.listOfVodAssets[Contents.ContentID].IsEnabled && this.listOfVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentID].IsPrivate == null || this.listOfVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentID].Platform == null || this.listOfVodAssets[Contents.ContentID].Platform == undefined || (this.listOfVodAssets[Contents.ContentID].Platform.includes("Website"))) )
              || (this.listOfVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfVodAssets[Contents.Contentid].Codec && (this.listOfVodAssets[Contents.Contentid].Codec != '3') && (this.listOfVodAssets[Contents.Contentid].Codec != '4') && (this.listOfVodAssets[Contents.Contentid].Codec != '5') && (this.listOfVodAssets[Contents.Contentid].Codec != '9') && (this.listOfVodAssets[Contents.Contentid].Codec != '6') && (this.listOfVodAssets[Contents.Contentid].Codec != '10') && this.listOfVodAssets[Contents.Contentid].IsEnabled && this.listOfVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfVodAssets[Contents.Contentid].IsPrivate == null || this.listOfVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfVodAssets[Contents.Contentid].Platform == null || this.listOfVodAssets[Contents.Contentid].Platform == undefined || (this.listOfVodAssets[Contents.Contentid].Platform.includes("Website")))) 
              || (this.listOfVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfVodAssets[Contents.ContentiD].Codec && (this.listOfVodAssets[Contents.ContentiD].Codec != '3') && (this.listOfVodAssets[Contents.ContentiD].Codec != '4') && (this.listOfVodAssets[Contents.ContentiD].Codec != '5') && (this.listOfVodAssets[Contents.ContentiD].Codec != '9') && (this.listOfVodAssets[Contents.ContentiD].Codec != '6') && (this.listOfVodAssets[Contents.ContentiD].Codec != '10') && this.listOfVodAssets[Contents.ContentiD].IsEnabled && this.listOfVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentiD].Platform == null || this.listOfVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
                
                list.Contents.push(this.listOfVodAssets[Contents.ContentId] || this.listOfVodAssets[Contents.ContentID] || this.listOfVodAssets[Contents.Contentid] || this.listOfVodAssets[Contents.ContentiD])
                
                list.contentType.push( {
                  type: 'VOD',
                  contentId: Contents.ContentID
                })
                
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  list.Contents.sort(function(a, b) {
                    return a.Title.localeCompare(b.Title);
                  });
                }
              }

            } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {

              if( (this.listOfVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfVodAssets[Contents.ContentId].Codec && (this.listOfVodAssets[Contents.ContentId].Codec != '5') && (this.listOfVodAssets[Contents.ContentId].Codec != '9') && (this.listOfVodAssets[Contents.ContentId].Codec != '6') && (this.listOfVodAssets[Contents.ContentId].Codec != '10') && this.listOfVodAssets[Contents.ContentId].IsEnabled && this.listOfVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentId].IsPrivate == null || this.listOfVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentId].Platform == null || this.listOfVodAssets[Contents.ContentId].Platform == undefined || (this.listOfVodAssets[Contents.ContentId].Platform.includes("Website")))) 
              || (this.listOfVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfVodAssets[Contents.ContentID].Codec && (this.listOfVodAssets[Contents.ContentID].Codec != '5') && (this.listOfVodAssets[Contents.ContentID].Codec != '9') && (this.listOfVodAssets[Contents.ContentID].Codec != '6') && (this.listOfVodAssets[Contents.ContentID].Codec != '10') && this.listOfVodAssets[Contents.ContentID].IsEnabled && this.listOfVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentID].IsPrivate == null || this.listOfVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentID].Platform == null || this.listOfVodAssets[Contents.ContentID].Platform == undefined || (this.listOfVodAssets[Contents.ContentID].Platform.includes("Website"))) )
              || (this.listOfVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfVodAssets[Contents.Contentid].Codec && (this.listOfVodAssets[Contents.Contentid].Codec != '5') && (this.listOfVodAssets[Contents.Contentid].Codec != '9') && (this.listOfVodAssets[Contents.Contentid].Codec != '6') && (this.listOfVodAssets[Contents.Contentid].Codec != '10') && this.listOfVodAssets[Contents.Contentid].IsEnabled && this.listOfVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfVodAssets[Contents.Contentid].IsPrivate == null || this.listOfVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfVodAssets[Contents.Contentid].Platform == null || this.listOfVodAssets[Contents.Contentid].Platform == undefined || (this.listOfVodAssets[Contents.Contentid].Platform.includes("Website")))) 
              || (this.listOfVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfVodAssets[Contents.ContentiD].Codec && (this.listOfVodAssets[Contents.ContentiD].Codec != '5') && (this.listOfVodAssets[Contents.ContentiD].Codec != '9') && (this.listOfVodAssets[Contents.ContentiD].Codec != '6') && (this.listOfVodAssets[Contents.ContentiD].Codec != '10') && this.listOfVodAssets[Contents.ContentiD].IsEnabled && this.listOfVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentiD].Platform == null || this.listOfVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
                
                list.Contents.push(this.listOfVodAssets[Contents.ContentId] || this.listOfVodAssets[Contents.ContentID] || this.listOfVodAssets[Contents.Contentid] || this.listOfVodAssets[Contents.ContentiD])
                
                list.contentType.push( {
                  type: 'VOD',
                  contentId: Contents.ContentID
                })
                
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  list.Contents.sort(function(a, b) {
                    return a.Title.localeCompare(b.Title);
                  });
                }
              }

            } else {

              if( (this.listOfVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfVodAssets[Contents.ContentId].IsEnabled && this.listOfVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentId].IsPrivate == null || this.listOfVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentId].Platform == null || this.listOfVodAssets[Contents.ContentId].Platform == undefined || (this.listOfVodAssets[Contents.ContentId].Platform.includes("Website")))) 
              || (this.listOfVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfVodAssets[Contents.ContentID].IsEnabled && this.listOfVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentID].IsPrivate == null || this.listOfVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentID].Platform == null || this.listOfVodAssets[Contents.ContentID].Platform == undefined || (this.listOfVodAssets[Contents.ContentID].Platform.includes("Website"))) )
              || (this.listOfVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfVodAssets[Contents.Contentid].IsEnabled && this.listOfVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfVodAssets[Contents.Contentid].IsPrivate == null || this.listOfVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfVodAssets[Contents.Contentid].Platform == null || this.listOfVodAssets[Contents.Contentid].Platform == undefined || (this.listOfVodAssets[Contents.Contentid].Platform.includes("Website")))) 
              || (this.listOfVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfVodAssets[Contents.ContentiD].IsEnabled && this.listOfVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentiD].Platform == null || this.listOfVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
                
                list.Contents.push(this.listOfVodAssets[Contents.ContentId] || this.listOfVodAssets[Contents.ContentID] || this.listOfVodAssets[Contents.Contentid] || this.listOfVodAssets[Contents.ContentiD])
                
                list.contentType.push( {
                  type: 'VOD',
                  contentId: Contents.ContentID
                })
                
                if(this.listOfAppConfiguration.Contentorder == '1') {
                  list.Contents.sort(function(a, b) {
                    return a.Title.localeCompare(b.Title);
                  });
                }
              }

            }

            } else {
                if( (this.listOfLive.hasOwnProperty(Contents.ContentId) && this.listOfLive[Contents.ContentId].IsEnabled && this.listOfLive[Contents.ContentId].IsEnabled == '1' && (this.listOfLive[Contents.ContentId].IsPrivate != '1' || this.listOfLive[Contents.ContentId].IsPrivate == null || this.listOfLive[Contents.ContentId].IsPrivate == undefined) && (this.listOfLive[Contents.ContentId].AppPlatforms == null || this.listOfLive[Contents.ContentId].AppPlatforms == undefined || (this.listOfLive[Contents.ContentId].AppPlatforms.includes("Website")))) || (this.listOfLive.hasOwnProperty(Contents.ContentID) && this.listOfLive[Contents.ContentID].IsEnabled && this.listOfLive[Contents.ContentID].IsEnabled == '1' && (this.listOfLive[Contents.ContentID].IsPrivate != '1' || this.listOfLive[Contents.ContentID].IsPrivate == null || this.listOfLive[Contents.ContentID].IsPrivate == undefined) && (this.listOfLive[Contents.ContentID].AppPlatforms == null || this.listOfLive[Contents.ContentID].AppPlatforms == undefined || (this.listOfLive[Contents.ContentID].AppPlatforms.includes("Website"))) ) || (this.listOfLive.hasOwnProperty(Contents.Contentid) && this.listOfLive[Contents.Contentid].IsEnabled && this.listOfLive[Contents.Contentid].IsEnabled == '1' && (this.listOfLive[Contents.Contentid].IsPrivate != '1' || this.listOfLive[Contents.Contentid].IsPrivate == null || this.listOfLive[Contents.Contentid].IsPrivate == undefined) &&(this.listOfLive[Contents.Contentid].AppPlatforms == null || this.listOfLive[Contents.Contentid].AppPlatforms == undefined || (this.listOfLive[Contents.Contentid].AppPlatforms.includes("Website")))) || (this.listOfLive.hasOwnProperty(Contents.ContentiD) && this.listOfLive[Contents.ContentiD].IsEnabled && this.listOfLive[Contents.ContentiD].IsEnabled == '1' && (this.listOfLive[Contents.ContentiD].IsPrivate != '1' || this.listOfLive[Contents.ContentiD].IsPrivate == null || this.listOfLive[Contents.ContentiD].IsPrivate == undefined) && (this.listOfLive[Contents.ContentiD].AppPlatforms == null || this.listOfLive[Contents.ContentiD].AppPlatforms == undefined || (this.listOfLive[Contents.ContentiD].AppPlatforms.includes("Website")))) ){
                  list.Contents.push(this.listOfLive[Contents.ContentId] || this.listOfLive[Contents.ContentID] || this.listOfLive[Contents.Contentid] || this.listOfLive[Contents.ContentiD] )
                  list.contentType.push( {
                    type: Contents.Type,
                    contentId: Contents.ContentID
                  })
                  if(this.listOfAppConfiguration.Contentorder == '1') {
                    list.Contents.sort(function(a, b) {
                      return a.Title[0].localeCompare(b.Title[0]);
                    });
                  }
              }
              
            }

        });

        if(list.Contents.length > '0') {
          perfinalList.push(list)
        }
              
        } 
      });
      }
        finalLists.push(perfinalList);
       
      }
    }


    if(userProfile == '21') {
        let perfinalprivateUserContent = [];
        let privateUserContent = {Name :'My Content', Contents : []};
        for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {

          if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              if(this.listOfAppConfiguration.Contentorder == '1') {
                privateUserContent.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                privateUserContent.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }
          } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              if(this.listOfAppConfiguration.Contentorder == '1') {
                privateUserContent.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                privateUserContent.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }
          } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              if(this.listOfAppConfiguration.Contentorder == '1') {
                privateUserContent.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                privateUserContent.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }
          } else {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              if(this.listOfAppConfiguration.Contentorder == '1') {
                privateUserContent.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                privateUserContent.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }
          }
        }
        for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
          if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == username && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
            privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
            if(this.listOfAppConfiguration.Contentorder == '1') {
              privateUserContent.Contents.sort(function(a, b) {
                return a.Title[0].localeCompare(b.Title[0]);
              });
            } else {
              privateUserContent.Contents.sort(function (a, b) {
                return b.JobID - a.JobID;
              });
            }
          }
        }
        newContentCategory.push( {
          title: 'My Content',
          vertical: '0'
        })
        
        perfinalprivateUserContent.push(privateUserContent);
        finalLists.push(perfinalprivateUserContent);
    } else {
      let perfinalprivateUserContent = [];
        let privateUserContent = {Name :'My Content', Contents : []};
        for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
          
          if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              if(this.listOfAppConfiguration.Contentorder == '1') {
                privateUserContent.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                privateUserContent.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }
          } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              if(this.listOfAppConfiguration.Contentorder == '1') {
                privateUserContent.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                privateUserContent.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }
          } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              if(this.listOfAppConfiguration.Contentorder == '1') {
                privateUserContent.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                privateUserContent.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }
          } else {
            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == username && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
              if(this.listOfAppConfiguration.Contentorder == '1') {
                privateUserContent.Contents.sort(function(a, b) {
                  return a.Title.localeCompare(b.Title);
                });
              } else {
                privateUserContent.Contents.sort(function (a, b) {
                  return b.JobID - a.JobID;
                });
              }
            }
          }
          
        }
        for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
          if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == username && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
            privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
            if(this.listOfAppConfiguration.Contentorder == '1') {
              privateUserContent.Contents.sort(function(a, b) {
                return a.Title[0].localeCompare(b.Title[0]);
              });
            } else {
              privateUserContent.Contents.sort(function (a, b) {
                return b.JobID - a.JobID;
              });
            }
          }
        }
        if(privateUserContent.Contents.length != '0') {
          newContentCategory.push( {
            title: 'My Content',
            vertical: '0'
          })
        }

        perfinalprivateUserContent.push(privateUserContent);
        finalLists.push(perfinalprivateUserContent);
    }


      localStorage.setItem('newContentCategory', JSON.stringify(newContentCategory));

      localStorage.setItem('jfinalLists', JSON.stringify(finalLists));

      localStorage.setItem('bgColor',this.listOfAppConfiguration.Color);
      localStorage.setItem('contentStatsText',this.listOfAppConfiguration.Contentstats[0]);
      localStorage.setItem('textColor',this.listOfAppConfiguration.TextColor);
      localStorage.setItem('welcomeMsg',this.listOfAppConfiguration.WelcomeMessage[0]);
      localStorage.setItem('contentCategories',this.listOfAppConfiguration.ContentCategories);
      localStorage.setItem('imageBaseURI',this.listOfAppConfiguration.ImageBaseURI);
      localStorage.setItem('videoBaseURI',this.listOfAppConfiguration.VideoBaseURI);
      localStorage.setItem('liveVideoBaseURI',this.listOfAppConfiguration.LiveVideoBaseURI);
      localStorage.setItem('ratingEnable',this.listOfAppConfiguration.Rating);
      localStorage.setItem('contentStats',this.listOfAppConfiguration.Stats);
      localStorage.setItem('durationEnable',this.listOfAppConfiguration.ContentDuration);
      localStorage.setItem('overlayBackground',this.listOfAppConfiguration.OverlayBackground);
      localStorage.setItem('overlayText',this.listOfAppConfiguration.OverlayText);
      localStorage.setItem('overlayTextEnabled',this.listOfAppConfiguration.TextEnabled);
      localStorage.setItem('imagetypeforslider',this.listOfAppConfiguration.Imagetypeforslider);
      localStorage.setItem('imagetypeforlist',this.listOfAppConfiguration.Imagetypeforlist);
      localStorage.setItem('imagetypeforposter',this.listOfAppConfiguration.Imagetypeforposter);
      localStorage.setItem('bypassdetails',this.listOfAppConfiguration.Bypassdetails);
      localStorage.setItem('myaccountemail',this.listOfAppConfiguration.Myaccountemail[0]);
      localStorage.setItem('myaccountfirstname',this.listOfAppConfiguration.Myaccountfirstname[0]);
      localStorage.setItem('myaccountlastname',this.listOfAppConfiguration.Myaccountlastname[0]);
      localStorage.setItem('myaccountsubscriberid',this.listOfAppConfiguration.Myaccountsubscriberid[0]);
  
      this.props.history.push('/mtab')
  }//end of querydata

 render() {
   
  this.toggleShowPassword = () => (event) => {
    this.setState({ showPassword: !this.state.showPassword });
  }

  this.playerSignUp = () => (event) => {
    if (this.state.isStaging) {
      window.open('https://platform-staging.v-nova.com/playersignup', '_self')
    } else {
      window.open('https://platform.v-nova.com/playersignup', '_self')
    }
  }

  this.goToForgotPwd = () => (event) => {
    event.preventDefault();
    this.props.history.push('/forgotPassword');
    window.location.reload();
  }


   return (
      <div className="container-fluid prelogin_bg">
      <div className="row">

      <div className="col-md-offset-3 col-md-8 col-xs-12 prelogin_container">
      <div className="col-md-2 col-sm-3 col-xs-1"></div>
      <div className="col-md-5 col-sm-6 col-xs-10 login_container">
      <form id="login-form" name="form"  onSubmit={this.handleSubmit}  role="form">
      
      <div className="logo_container">
       {
          (this.state.isStaging) ? (
            <div>
              <img src={logo} alt="LOGO"/>
              <div><img src={MpegLcevcLogo} alt="MPEG-5 LCEVC"/></div>
              <div>
                <span className="staging_platform">STAGING</span>
              </div>
            </div>
          ) : (
            <span>
              <img src={logo} alt="LOGO"/>
              <div><img src={MpegLcevcLogo} alt="MPEG-5 LCEVC"/></div>
            </span>
          )
        }
      </div>
      
      <div className="col-md-12">
      <div className="col-md-2"></div>
      <div className="form-group col-md-8 login_form_group">                
      <div className="login__row display_flex">
      
      <input className="login__input" type="text" id="luser" value={this.state.luser} onChange={this.handleChange} autoFocus minLength="1" required/>
      <span className="floating-label">Username</span>
      </div>
      </div>
      <div className="col-md-2"></div>
      </div>

      <div className="col-md-12">
      <div className="col-md-2"></div>
      <div className="form-group col-md-8 login_form_group ">                
      <div className="login__row display_flex">
      
      {
        (this.state.showPassword) ? (
          <span><input className="login__input" type="text" id="lpass" value={this.state.lpass} onChange={this.handleChange} required />
          <span className="floating-label">Password</span></span>
        ) : (
          <span><input className="login__input" type="password" id="lpass" value={this.state.lpass} onChange={this.handleChange} required />
          <span className="floating-label">Password</span></span>
        )
      }
      {
        (this.state.showPassword) ? (
          <span className="glyphicon glyphicon-eye-open form-control-feedback toggle_password" onClick={this.toggleShowPassword()}></span>
        ) : (
          <span className="glyphicon glyphicon-eye-close form-control-feedback toggle_password" onClick={this.toggleShowPassword()}></span>
        )
      }
     
      </div>
      </div>
      <div className="col-md-2"></div>
      </div>

      {
        (this.state.isStaging) ? (
          <div className="col-md-12 checkbox_container">
            &nbsp;<input className="checkbox_input position_absolute" type="checkbox" name="terms" id="terms" required />&emsp;&nbsp;&nbsp;&nbsp;<span>I accept the <a href="https://platform-staging.v-nova.com/terms" className="prelogin_anchor">Terms and conditions</a></span>
          </div>
        ) : (
          <div className="col-md-12 checkbox_container">
            &nbsp;<input className="checkbox_input position_absolute" type="checkbox" name="terms" id="terms" required />&emsp;&nbsp;&nbsp;&nbsp;<span>I accept the <a href="https://platform.v-nova.com/terms" className="prelogin_anchor">Terms and conditions</a></span>
          </div>
        )
      } 

      {
        (this.state.showLoginBtn) ? (
          <div className="col-md-12 login_btn_container padding_top_20">
             <button id="loginbutton" className="btn login_btn" type="submit" value="Submit"><span>Sign In</span></button>  
          </div>
        ) : (
          <div id="loader" className="col-md-12 login_btn_container loginLoaderContainer">
            <div className="loader loginLoader"></div>
          </div>
        )
      }

      </form>
      <div className="col-md-12 padding_top_20 display_flex">
        <div className="width_50">
            <span className="link_text prelogin_anchor" onClick={this.playerSignUp()}>Sign Up</span>
        </div>
        <div className="width_50">
            <span className="link_text prelogin_anchor" onClick={this.goToForgotPwd()}>Forgot Password</span>
        </div>
      </div>

      <div className="col-md-12" style={{paddingTop: "3px",opacity: "0.5"}}>
       Version : {version.Version}
      </div>
     
      </div>
      <div className="col-md-5 col-sm-3 col-xs-1"></div>
      </div>

      

      </div>

      <div> 
        { 
          (this.state.showLoader)?( 
            <div id="launch_loading"></div>
          ) : ( <span></span> ) 
        }
      </div>

      </div>   
      );
   }
}

export default Login;